import { categoryKey } from '../scripts/Editor/utils/productionUtils';
const norm = value => String(value || '').toLowerCase().replace(/[^a-z0-9]/g, '');
const tokens = value => new Set(String(value || '').toLowerCase().replace(/drawings/g, 'drawing').replace(/lamps?|lights?|lighting/g, 'light').replace(/[^a-z0-9 ]/g, ' ').split(/\s+/).filter(t => t.length > 2 && !['the', 'and', 'for', 'with', 'from'].includes(t)));
export const resourceCategory = category => !['cast', 'backgroundextras'].includes(categoryKey(category));
export const initialRows = suggestions => {
  const seen = new Map();
  for (const suggestion of suggestions) {
    if (!resourceCategory(suggestion.category)) continue;
    const key = norm(suggestion.name);
    const previous = seen.get(key);
    if (!previous) seen.set(key, { ...suggestion, selected: false });
    else if (categoryKey(previous.category) !== categoryKey(suggestion.category)) previous.reason = [previous.reason, suggestion.reason, `Alternative category: ${suggestion.category}; confirm the actual use.`].filter(Boolean).join(' ');
  }
  return [...seen.values()];
};
export const candidateItems = (row, inventory) => inventory.filter(item => {
  const own = tokens(row.name), theirs = tokens(`${item.name} ${item.notes} ${item.description}`);
  return norm(row.name) === norm(item.name) || own.size > 0 && [...own].filter(t => theirs.has(t)).length / own.size >= 0.5;
});
export const reviewRow = (row, inventory, sceneId) => {
  const candidates = candidateItems(row, inventory);
  const exact = candidates.filter(i => norm(i.name) === norm(row.name) && categoryKey(i.category) === categoryKey(row.category));
  const existing = row.existingKey ? inventory.find(i => i.key === row.existingKey) : exact.length === 1 ? exact[0] : null;
  const linked = existing ? existing.scenes.includes(String(sceneId)) : !inventory.length && row.inThisScene;
  const resolved = Boolean(existing || candidates.length === 0 || row.distinctNew && exact.length === 0);
  return { candidates, existing, linked, resolved, selectable: Boolean(row.name.trim() && resourceCategory(row.category) && !linked), valid: Boolean(row.name.trim() && resourceCategory(row.category) && resolved && !linked) };
};
export const approvedItems = (rows, inventory, sceneId) => {
  const seen = new Set();
  return rows.filter(row => row.selected).flatMap(row => {
    const state = reviewRow(row, inventory, sceneId);
    if (!state.valid) return [];
    const key = state.existing?.key || `${categoryKey(row.category)}|${norm(row.name)}`;
    if (seen.has(key)) return [];
    seen.add(key);
    return [{ name: state.existing?.name || row.name.trim(), category: state.existing?.category || row.category, ...(state.existing ? { existingKey: state.existing.key } : row.distinctNew ? { distinctNew: true } : {}) }];
  });
};